export default {
  getAllNotifications: '/notifications/getAllNotifications',
  getTodaysNotifications: '/notifications/getTodaysNotifications'
}
